import { useDispatch, useSelector } from "react-redux";
import classes from "./ChooseLangModal.module.css";
import { setIsLangModalShown, setLanguage } from "../../redux/globalFunctions";
import norwayFlag from "../../images/NorwayFlag.svg";
import englishFlag from "../../images/EnglishFlag.svg";
import translations from "../../en.json";
import translationsNo from "../../no.json";

export function ChooseLangModal() {
  const { language } = useSelector((state) => state.global);
  const dispatch = useDispatch();

  const modalText =
    language === "en" ? translations.langSwitcher : translationsNo.langSwitcher;

  return (
    <div className={classes.overlay}>
      <div className={classes.container}>
        <p>{modalText.title}</p>
        <div className={classes.buttons}>
          <button
            onClick={() => {
              dispatch(setLanguage("en"));
              dispatch(setIsLangModalShown(false));
            }}
          >
            <img src={englishFlag} alt={modalText.englishAlt} />
          </button>
          <button
            onClick={() => {
              dispatch(setLanguage("no"));
              dispatch(setIsLangModalShown(false));
            }}
          >
            <img src={norwayFlag} alt={modalText.norwayAlt} />
          </button>
        </div>
      </div>
    </div>
  );
}
